import {
    CREDITS_PACKAGE_1,
    CREDITS_PACKAGE_2,
    CREDITS_PACKAGE_3,
    creditsConfig,
} from '../../../../credits-config';

export const priceCards = [
    {
        label: 'S',
        badge: null,
        ...creditsConfig[CREDITS_PACKAGE_1],
    },
    {
        label: 'M',
        badge: '30% Rabatt',
        ...creditsConfig[CREDITS_PACKAGE_2],
    },
    {
        label: 'L',
        badge: '45% Rabatt',
        ...creditsConfig[CREDITS_PACKAGE_3],
    },
];
